<template>
 <div class="tableDiv">
  <el-table :data="tableData" stripe style="width: 100%" :empty-text="$t('desc.noData')">
    <el-table-column type="index" :label="$t('title.serialNumber')" width="60"> </el-table-column>
    <el-table-column prop="country" :label="$t('title.country')"> </el-table-column>
    <el-table-column v-if="isShowKArea" prop="area" :label="$t('title.region')">
    </el-table-column>
    <el-table-column v-if="isShowKCenter" prop="center" :label="regionType=='PAC'?$t('title.provinceFen'):$t('title.customerCenter')">
    </el-table-column>
    <el-table-column v-if="isShowOffice" prop="office" :label="$t('title.liaison')">
    </el-table-column>
    <el-table-column prop="brand" :label="$t('title.brandName')"> </el-table-column>
   <el-table-column :label="$t('title.operate')" :width="isShowOffice && regionType!='BV' ? '180' : '120'" fixed="right">
      <template slot-scope="scope">
        <el-button
          v-if="isShowOffice && regionType!='BV'"
          type="default"
          icon="el-icon-location-information"
          :title="$t('button.managementArea')"
          circle
          size="mini"
          style="margin-top: 5px"
          @click="showCityDialog(scope.row)"
          >
        </el-button>
        <el-button
          v-if="hasUpdateAuth"
          type="primary"
          icon="el-icon-edit"
          :title="$t('button.update')"
          circle
          size="mini"
          @click="showEditDialog(scope.row)"
        ></el-button>
        <template v-if="hasDeleteAuth">
          <el-popconfirm
            placement="top"
            :confirmButtonText="$t('button.delete')"
            :cancelButtonText="$t('button.cancel')"
            icon="el-icon-info"
            iconColor="red"
            :title="$t('title.confirmDelete')"
            @confirm="delRow(scope.$index, scope.row, tableType)"
          >
            <el-button
              type="danger"
              :title="$t('button.delete')"
              icon="el-icon-delete"
              circle
              size="mini"
              slot="reference"
            ></el-button>
          </el-popconfirm>
        </template>
      </template>
    </el-table-column>
  </el-table>
 </div>
</template>

<script>
export default {
  name: "index",
  props: {
    regionType:"",
    hasUpdateAuth: false,
    hasDeleteAuth: false,
    isShowKArea: false,
    isShowKCenter: false,
    isShowOffice: false,
    tableType: "",
    tableData: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    addMTRow() {
      this.$emit("addMTRow", true);
    },
    //空压机类型 删除
    delRow(index, row, tableType) {
      this.$emit("delRow", index, row, tableType);
    },
    showEditDialog(row) {
      this.$emit("showEditDialog", true, row);
    },
    showCityDialog(row) {
      this.$emit("showCityDialog", true, row);
    },
  },
};
</script>

<style>
</style>
